import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({ providedIn: 'root' })
export class DiademOnlyGuard {
    constructor(private auth: AuthService, private router: Router) {}

    canActivate(): boolean {
        if (!this.auth.isClient()) return true;
        this.router.navigate(['/']);
        return false;
    }
}
